export default function Values() {
  const values = [
    {
      icon: 'ri-user-heart-line',
      title: 'Customer First',
      description: 'Every decision we make starts with how it impacts the customer experience. We build tools that make support teams heroes.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trust & Transparency',
      description: 'We believe in honest communication, clear pricing, and AI that explains its decisions. No black boxes, no surprises.'
    },
    {
      icon: 'ri-rocket-2-line',
      title: 'Innovation',
      description: 'We push the boundaries of what AI can do in customer support, constantly improving and adapting to new challenges.'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaboration',
      description: 'Our AI agents are designed to work with humans, not replace them. We believe the best support comes from human-AI collaboration.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Results Driven',
      description: 'We measure success by the impact we create: reduced costs, faster resolutions, and happier customers.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainable Growth',
      description: 'We help businesses scale sustainably, growing their support capabilities without proportional cost increases.'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#B8985F]/40 bg-[#B8985F]/10 mb-6">
            <i className="ri-heart-line text-[#B8985F] text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-[13px] text-[#B8985F] font-medium">Our Values</span>
          </div>
          <h2 className="text-[36px] md:text-[42px] font-bold text-black leading-[1.2] mb-6">
            What We Stand For
          </h2>
          <p className="text-[16px] md:text-[18px] text-[#555] max-w-[700px] mx-auto">
            Our core values guide everything we do, from product development to customer relationships.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-[#F8F8F8] rounded-lg p-6 md:p-8 hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 rounded-full bg-[#B8985F]/20 flex items-center justify-center mb-5">
                <i className={`${value.icon} text-[#B8985F] text-2xl w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-[20px] md:text-[22px] font-bold text-black mb-3">
                {value.title}
              </h3>
              <p className="text-[14px] md:text-[15px] text-[#555] leading-[1.7]">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
